module.exports = __webpack_public_path__ + "img/2-certifications-ml_cut.png";